module.exports = __webpack_public_path__ + "static/placelogo-5cc19536df87141f239fe3ce05038440.webp";